import cloneDeep from 'lodash/cloneDeep';
import { groupByQuery, timeseriesQuery } from '../constants';

export const buildTimeseriesQuery = ({ metrics, filter, interval, granularity, isLiveMode }) => {
    const q = {
        ...cloneDeep(timeseriesQuery),
        interval,
        filter,
        metrics: [...metrics],
        granularity: granularity || 'ALL',
        isLiveMode
    };
    return q;
};

export const buildGroupByQuery = ({ metrics, dimension, filter, interval }) => {
    const q = {
        ...cloneDeep(groupByQuery),
        interval,
        filter,
        metrics: [...metrics],
        groupBy: [dimension],
        sortBy: [{ metric: metrics[0], order: 'desc' }],
    };
    return q;
}

export function formatQueryStatus({ isFetching, isError, isEmpty, refetch }) {
  return {
    fetchData: refetch,
    isLoading: isFetching,
    showError: isError,
    isEmpty,
  };
}
